import { createClient, FunctionInvokeOptions } from "@supabase/supabase-js";

import {
  ApiResponseBodyType,
  Database,
  EdgeFunctionOptionsType,
  EdgeFunctionReturnType,
  EdgeFunctionsEnum,
} from "@libs/schemas";
import { envVariables } from "@/utils/envVariables";

export const supabaseClient = createClient<Database>(
  envVariables.VITE_SUPABASE_URL,
  envVariables.VITE_SUPABASE_PUBLISHABLE_KEY,
  {
    auth: {
      autoRefreshToken: true,
      persistSession: true,
      detectSessionInUrl: false,
    },
  },
);

export const invokeEdgeFunction = async <T extends EdgeFunctionsEnum>({
  func,
  opts,
  method = "POST",
}: {
  func: T;
  opts?: EdgeFunctionOptionsType[T];
  method: FunctionInvokeOptions["method"];
}) => {
  const result = await supabaseClient.functions.invoke<
    EdgeFunctionReturnType[T]
  >(func, { ...(opts ?? {}), method });

  if (result.error) {
    // To get full error message, we need to parse the error response
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
    const error = await result.error.context.json();

    // Errors are returned in the body's message field from API
    return { ...result, error: error as ApiResponseBodyType };
  }

  return {
    data: result.data,
    error: result.error as null,
  };
};
